module.exports = __webpack_public_path__ + "img/rank-8.ae93dbe.svg";